module.exports = __webpack_public_path__ + "static/fonts/Oxanium-ExtraLight.1481f73d.ttf";